export default __webpack_public_path__ + "static/media/lares.39b19094.jpg";